import { payload } from "../../../../../../node_modules/@sveltejs/kit/src/runtime/client/payload.js";
const env = payload.env;

export const PUBLIC_APP_ENV = "production";
export const PUBLIC_WEBSITE_API_URL = "";
export const PUBLIC_WEBSITE_GRAPHQL_URL = "";
export const PUBLIC_WEBSITE_MUTATIONS_GRAPHQL_URL = "";
